
'use strict';

var $ = require('jquery'),
  config = require('../config'),
  $global = require('../globalElements'),
  _ = require('underscore'),
  Backbone = require('backbone');

import ScrollTo from '../../components/ScrollTo/ScrollTo';

Backbone.$ = $;

var CategoriesView = Backbone.View.extend({

  events: {
    'click .Categories-item-link': 'showDrawer',
    'click .category-heading-container': 'showflyoutMenu',
    'click .responsive-heading-container': 'hideflyoutMenu',
    'mouseover .flyout-Desktop .primary-category-container': 'showSubCategory',
    'mouseout .flyout-Desktop .primary-category-container': 'hideSubCategory'
  },

  initialize: function() {

    this.$container     = $('.Main');                                     // container, where overlay is placed
    this.$overlay       = $('<div class="Overlay Overlay--mobile" />');   // overlay (for mobile)
    this.$modal         = $('<div class="modal--SubCategories" />');      // container for subcategories (on mobile)
    this.isVisible      = config.classes.isVisible;
    this.$items         = this.$('.js-open-drawer');
    this.showItemsClass = 'show-items';
    this.focusOnProductCategory();
    this.showFlyoutOnEnter();
    this.showSubcategoryOnEnter();
    this.hideFlyoutOnEnter();
    // adding overlay and a modal wrapper for mobile view
    this.$overlay.append(this.$modal).appendTo(this.$container);

    // hide mobile
    $global.$document.on('click', this.$overlay, _.bind(this.onOverlayClick, this));

    $(window).on('resize', () => {
      this.focusOnProductCategory();
    })
  },

  focusOnProductCategory() {
    const isResponsive = window.innerWidth <= 1279;
    if (isResponsive) {
      $('.category-heading-container').attr('tabindex', '0');
    } else {
      $('.category-heading-container').attr('tabindex', '1');
    }
  },

  onOverlayClick: function(e) {
    var isOverlayMobile = $(e.target).is('.Overlay--mobile');

    // close modal when clicked on the close button or overlay
    if (isOverlayMobile || $(e.target).is('.js-close-modal')) {
      this.hideModal();
      e.preventDefault();
    }

    // show all category items
    var $showHideButton = $(e.target);
    if (isOverlayMobile || $showHideButton.is('.js-show-items')) {
      let topOfButton = parseInt($showHideButton.offset().top);
      if (+($showHideButton.attr('is-expanded'))) {
        $showHideButton.attr('is-expanded', 0);
        $showHideButton.text($showHideButton.attr('expanded-label'));
        $showHideButton.attr('aria-label', $showHideButton.attr('expanded-label') + ' Categories');
        this.hideItems(e.target);
      }
      else {
        $showHideButton.attr('is-expanded', 1);
        $showHideButton.text($showHideButton.attr('collapse-label'));
        $showHideButton.attr('aria-label', $showHideButton.attr('collapse-label') + ' Categories');
        this.showItems($showHideButton, topOfButton);
      }
      e.preventDefault();
    }
  },

  showDrawer: function(e) {
    e.preventDefault();

    this.$currentItem = $(e.currentTarget).parents('.js-open-drawer');
    this.$drawer = $('.js-drawer', this.$currentItem);
    this.$currentlink = $('.Categories-item-link', this.$currentItem);
    //close the drawer if clicked on an active category
    if (this.$currentItem.hasClass(this.isVisible)) {
      this.hideModal();
      return;
    }

    if (!this.$items.hasClass(this.isVisible)) {
      this.showModal();
      return;
    }

    this.hideModal();
    this.showModal();
  },

  showModal: function() {
    $('.Categories-item-link').attr('aria-expanded', 'false');
    $('.js-drawer').attr('aria-hidden', 'true');
    $('.js-drawer').attr('style', 'display: none');
    //populate the modal and position it right below the sticky header (on mobile);
    this.$modal.empty();
    this.$drawer.clone().appendTo(this.$modal);
    this.$currentlink.clone().appendTo(this.$modal);

    this.$drawer[0].style.display = 'block';
    this.$drawer[0].setAttribute('aria-hidden', false);
    this.$currentlink[0].setAttribute('aria-expanded', true);
    this.$currentItem.addClass(this.isVisible);
  },

  hideModal: function() {
    this.$items.filter('.' + this.isVisible).removeClass(this.isVisible);
    this.$drawer[0].style.display = 'none';
    this.$drawer[0].setAttribute('aria-hidden',true);
    this.$currentlink[0].setAttribute('aria-expanded', false);
    this.$currentlink[0].focus();
  },

  showflyoutMenu: function() {
    const isResponsive = window.innerWidth <= 1279;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1279;
    if (isResponsive) {
      const heroBanner = document.getElementById('manufacturerHeroBanner');
      const productCards = document.getElementById('manufacturerHiddenResponsive');
      const newsletterBanner = document.getElementById('newsletterBanner');
      const categoryHeadingContainer = document.getElementById('categoryHeadingContainer');
      heroBanner.style.display = 'none';
      productCards.style.display = 'none';
      newsletterBanner.style.display = 'none';
      categoryHeadingContainer.style.display = 'none';
      $('.responsive-flyout').attr('style', 'display: block');
      $('.responsive-heading-container').attr('tabindex', '0');
      const animationDiv = document.querySelector('.responsive-flyout');
      animationDiv.style.animation = 'slideInRight 300ms ease-out';
      const primaryCategoryItem = document.querySelector('.flyout-Responsive .primary-category-container');
      if (isTablet) {
        primaryCategoryItem.classList.add('selected');
      }
      const secondaryCategoryDiv = document.querySelector('.Secondary-Category .sub-category-container');
      secondaryCategoryDiv.style.display = 'grid';

      const primaryDivs = document.querySelectorAll('.flyout-Responsive .primary-category-container');
      const secondaryDivs = document.querySelectorAll('.Secondary-Category .sub-category-container');
      const selectedclass = document.querySelectorAll('.selected');
      primaryDivs.forEach((div, index) => {
        div.addEventListener('click', () => {
          $('.flyout-Responsive .primary-category-container').removeClass('selected');
          if (selectedclass) {
            primaryCategoryItem.classList.remove('selected');
          }
          if (div.classList.contains('selected')) {
            div.classList.remove('selected');
          }
          if (isTablet) {
            div.classList.add('selected');
          }
          secondaryDivs.forEach((secondaryDiv) => {
            secondaryDiv.style.display = 'none';
          });
          secondaryDivs[index].style.display = 'grid';
        });
      });
    }
  },

  hideflyoutMenu: function() {
    const heroBanner = document.getElementById('manufacturerHeroBanner');
    const productCards = document.getElementById('manufacturerHiddenResponsive');
    const newsletterBanner = document.getElementById('newsletterBanner');
    const categoryHeadingContainer = document.getElementById('categoryHeadingContainer');
    heroBanner.style.display = 'block';
    productCards.style.display = 'block';
    newsletterBanner.style.display = 'block';
    categoryHeadingContainer.style.display = 'flex';
    const animationDiv = document.querySelector('.responsive-flyout');
    animationDiv.style.animation = 'slideOutRight 300ms ease-out';
    setTimeout(() => {
      $('.responsive-flyout').attr('style', 'display: none');
    }, 300);
  },

  showFlyoutOnEnter() {
    $('.category-heading-container').keydown((e) => {
      if (e.key === 'Enter') {
        this.showflyoutMenu();
      }
    })
  },

  showSubcategoryOnEnter() {
    const primaryDivs = document.querySelectorAll('.flyout-Desktop .primary-category-container');
    const secondaryDivs = document.querySelectorAll('.flyout-Desktop .sub-category-container');
    primaryDivs.forEach((div, index) => {
      $(div).keydown((e) => {
        if (e.key === 'Enter') {
          secondaryDivs.forEach((secondaryDiv) => {
            secondaryDiv.style.display = 'none';
          });
          secondaryDivs[index].style.display = 'grid';
          $('.sub-category-container a').focus(function() {
            $('.flyout-Desktop .primary-category-container').removeClass('selected');
            $(div).addClass('selected');
          });

          $('.sub-category-container a').blur(function() {
            $(div).removeClass('selected');
          });
          const lastElement = $(secondaryDivs[index]).children().last();
          $(lastElement).focusout(function() {
            $('.sub-category-container').attr('style', 'display: none');
          });
        }
      })
    });
  },

  showSubCategory() {
    const primaryDivs = document.querySelectorAll('.flyout-Desktop .primary-category-container');
    const secondaryDivs = document.querySelectorAll('.flyout-Desktop .sub-category-container');
    primaryDivs.forEach((div, index) => {
      div.addEventListener('mouseover', () => {
        secondaryDivs.forEach((secondaryDiv) => {
          secondaryDiv.style.display = 'none';
        });
        secondaryDivs[index].style.display = 'grid';
      });
    });
  },

  hideSubCategory() {
    $('.sub-category-container').attr('style', 'display: none');
  },

  hideFlyoutOnEnter() {
    $('.responsive-heading-container').keydown((e) => {
      if (e.key === 'Enter') {
        this.hideflyoutMenu();
      }
    })
  },

  showItems: function(target, topOfButton) {
    var minLen = 0;
    var focusSet = false;
    _.each(this.$items, function(item) {
      $(item).addClass(this.showItemsClass);
      if (!focusSet) {
        let top = parseInt($(item).offset().top);
        if (top + 50 > topOfButton) {
          let focusItem = $(item).find('a.Categories-item-link');
          if (focusItem.length) {
            focusItem[0].contentEditable = true;
            focusItem[0].focus();
            focusItem[0].contentEditable = false;
          }
          focusSet = true;
        }
        minLen++;
      }
    }, this);
    target.attr('minLen', minLen);
  },

  hideItems: function(target) {
    var minLen = +$(target).attr('minLen');
    var scrollToElm = null;
    _.each(this.$items, function(item) {
      minLen--;
      if (!scrollToElm && minLen < 3) {
        scrollToElm = item;
      }

      $(item).removeClass(this.showItemsClass);
    }, this);
    // Scroll to the top so that view button in viewport
    ScrollTo.scrollToElement({ selector: scrollToElm });
  }
}, {
  create: function($parent) {
    // Buying options views
    $parent.find('.js-Categories').each(function(n, el) {
      new CategoriesView({
        el: el
      });
    });
  }
});

module.exports = CategoriesView;



// WEBPACK FOOTER //
// ./assets/js/components/CategoriesView.js